<script>
import lazyLoadComponent from '@router/lazyload-component'
import formatDate from '@utils/format-date'
import { genderFilter, orderPaymentMethodMap, paymentStatusMapFilter, bookingStatusFilter } from '@utils/filter-value-to-text'
import cloneDeep from 'lodash/cloneDeep'

const initData = () => {
  return {
    params: [],
  }
}

const totalEditTypes = () => ['+', '-', '%', 'express']

export default {
  filters: {
    formatDate,
    paymentStatusMapFilter,
    bookingStatusFilter,
    genderFilter,
  },
  components: {
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
    TotalStatementDetailSectionPayment: () => lazyLoadComponent(import('./TotalStatementDetailSectionPayment')),
    TotalStatementDetailDropdown: () => lazyLoadComponent(import('./TotalStatementDetailDropdown')),
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    NoteAndDetailSectionPayment: () => lazyLoadComponent(import('./NoteAndDetailSectionPayment')),
    InvoiceInfoForShow: () => lazyLoadComponent(import('./InvoiceInfoForShow')),
  },
  props: {
    containerOrders: {
      type: Object,
      default: () => {},
    },
    orderType: {
      type: String,
      validator: (val) => {
        return ['reservation', 'prepaid', 'deposit', 'goods'].includes(val)
      },
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    defaultCoupon: {
      type: Object,
      default: () => ({}),
    },
    enabledEdit: {
      type: Boolean,
      default: false,
    },
    enabledAddition: {
      type: Boolean,
      default: false,
    },
    buyingPrepaidInfo: {
      type: Object,
      default: () => ({}),
    },
    isChildren: {
      type: Boolean,
      default: false,
    },
    memberInfo: {
      type: Object,
      default: () => ({}),
    },
    // 判斷是否只是美容師
    isEmployee: {
      type: Boolean,
      default: false,
    },
    // 顯示所有服務
    showServiceAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      orderPaymentMethodMap,
      submitData: {},
      MaxQty: 1,
      mainTableItemShow: true,

      reservationTypes: ['cosmetic-add', 'deposit', ...totalEditTypes()],
      goodsTypes: ['goods', ...totalEditTypes()],
      prepaidTypes: ['deposit', ...totalEditTypes()],
      depositTypes: [...totalEditTypes()],
      isActive: false,
      isActiveItem: ['main'],
      openStatus: [],
      parentOpenStatus: [],
      childOpenStatus: [],
      parentPartOrdersOpenStatus: true,
      childPartOrdersOpenStatus: [],
    }
  },
  computed: {
    installmentData() {
      if (this.containerOrders) {
        return this.containerOrders.installments
      } else {
        return this.submitData.installments
      }
    },
    /**
     * @description 如果是總訂單，則要顯示總訂單明細
     */
    forOrderTextShow() {
      if (this.orderType === 'reservation' && this.showServiceAll) {
        return '總訂單明細'
      }
      if (this.orderType === 'reservation' && !this.showServiceAll) {
        const { pet } = this.defaultValue
        return `${this.$t('reserve.CLIENT')}：${pet.name}的明細`
      }
      return '訂單計算'
    },
    /**
     * @description 總訂單 or 單一訂單文字顯示
     */
    allOrderOrSingleOrderBtnText() {
      if (this.showServiceAll) {
        return '查看總訂單中'
      }
      return '查看總訂單'
    },
    testAllOrders() {
      if (!this.containerOrders) return {}
      if (Object.keys(this.containerOrders).length > 0) {
        let cloneContainerOrders = cloneDeep(this.containerOrders)
        cloneContainerOrders['childrenOrderContainers']['items'].forEach((item) => {
          // 計算子container params的加減價
          item['paramsTotal'] = item.params.reduce((accu, cur) => {
            return accu + cur.price
          }, 0)
          if (Array.isArray(this.serviceItem) && this.showServiceAll) {
            item['orders'].forEach((eachOrderItem) => {
              const parentService = this.serviceItem.find((item) => item.orderId === eachOrderItem.parentId)
              if (parentService) {
                eachOrderItem['serviceTitle'] = parentService.title ?? ''
              }
            })
          }
        })
        cloneContainerOrders['paramsTotal'] = cloneContainerOrders.params.reduce((accu, cur) => {
          return accu + cur.price
        }, 0)
        return cloneContainerOrders
      } else {
        return {}
      }
    },
    /**
     * @description container的加購
     */
    containerParamsPayTotal() {
      let total = 0
      if (Object.keys(this.containerOrders).length > 0) {
        this.containerOrders.params.forEach((item) => {
          total = total + item.total
        })
      }
      return total
    },
    // 單筆預約服務資料
    serviceItem() {
      return this.findItemByType('cosmetic')
    },
    // 多筆預約服務資料
    multipleServices() {
      const services = this.defaultValue.params.filter(({ type }) => type === 'cosmetic')

      return services.length > 1 ? services : null
    },
    // 多筆預約服務與優惠券資料
    multipleServicesList() {
      const services = this.defaultValue.params.filter(({ type }) => type === 'cosmetic' || type === 'coupon')

      return services.length > 1 ? services : null
    },
    prepaidPlanItem() {
      return this.findItemByType('prepaid-plan')
    },
    /**
     * @description 方案抵扣顯示價格
     */
    prepaidDeductItem() {
      return this.findItemByType('prepaid')
    },
    couponItem() {
      const coupon = this.findItemByType('coupon')
      if (Object.keys(coupon).length === 0) return this.defaultCoupon
      return coupon
    },
    depositPlanItem() {
      return this.findItemByType('deposit-plan')
    },
    goodsItem() {
      return this.findItemByType('goods')
    },
    depositPlanItemPoint() {
      return this.depositPlanItem.bonus + this.depositPlanItem.point
    },
    params() {
      return this.submitData.params.filter(({ type }) => {
        return this[`${this.orderType}Types`].includes(type)
      })
    },
    serviceTotal() {
      let total = this.multipleServices?.length ? this.multipleServices.reduce((acc, cur) => acc + cur.total, 0) : this.serviceItem.total
      if (this.prepaidDeductItem.priceId) {
        total = 0
      } else if (this.couponItem.priceId) {
        total += this.couponItem.total
      } else {
        return total || 0
      }
      return total
    },
    childrenOrders() {
      return this.submitData.childrenOrders
    },
    isEmptyByOrderExtrafields() {
      return this.defaultValue.byOrderExtrafields instanceof Array
    },
    refundCheck() {
      return !!this.containerOrders.recommendRefundValue.amount
    },
  },
  watch: {
    defaultValue: {
      handler() {
        this.submitData = cloneDeep(this.defaultValue)
      },
      immediate: true,
      deep: true,
    },
    testAllOrders(nvl) {
      this.parentOpenStatus = []
      this.childOpenStatus = []
      this.childPartOrdersOpenStatus = []
      // 母訂單的orders > 0，則跑這邊
      if (nvl.orders.length > 0) {
        nvl.orders.forEach((item) => {
          this.parentOpenStatus.push(false)
        })
      }
      // 子訂單的orders > 0，則跑這邊
      if (nvl.childrenOrderContainers.items.length > 0) {
        const { items: containerItems } = nvl.childrenOrderContainers
        containerItems.forEach((containerItem) => {
          this.childPartOrdersOpenStatus.push(true)
          let tempStatus = []
          containerItem.orders.forEach((orderItem) => {
            tempStatus.push(false)
          })
          this.childOpenStatus.push(tempStatus)
        })
      }
    },
  },
  methods: {
    /**
     * @description 在reservation時，不要加入儲值金抵扣的價錢
     */
    composeNoDepositPrice(parentOrdersItem) {
      const depositItem = parentOrdersItem.params.find((item) => item.type === 'deposit')
      if (this.orderType === 'reservation' && depositItem) {
        return parentOrdersItem.payTotal + Math.abs(depositItem.total)
      }
      return parentOrdersItem.payTotal
    },
    /**
     * @description 查看總訂單按鈕
     */
    emitShowAll() {
      // !this.showServiceAll => 代表現在不是在看總訂單，所以按下去要看總訂單，結果：要讓parentPartOrdersOpenStatus = true
      if (!this.showServiceAll) {
        this.parentPartOrdersOpenStatus = true
      } else {
        this.parentPartOrdersOpenStatus = false
      }
      this.$emit('showAll', !this.showServiceAll)
    },
    /**
     * @description child 的 item是否有等級折價
     * @param {} childItem
     */
    isChildOrdersHasLevel(childItem) {
      try {
        return childItem.levelDiscount > 0
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 會員價的單價計算
     */
    memberPrice(item) {
      return item.price - item.levelDiscountValue / item.qty
    },
    /**
     * @description 是否顯示取消訂單 or 刪除訂單選項
     * PAID 就要顯示
     * UNPAID不顯示
     */
    showCancelOrDeleteFunc(containerItems) {
      return containerItems.paymentStatus === 'PAID'
    },
    /**
     * @description 發送containerId給父層
     */
    emitContainerId(item) {
      this.$emit('emitContainerId', item)
    },
    /**
     * @description 開啟關閉總訂單
     */
    clickDropDownIcon(type) {
      this[`${type}PartOrdersOpenStatus`] = !this[`${type}PartOrdersOpenStatus`]
    },
    openCloseOrdersForChild(index) {
      this.$set(this.childPartOrdersOpenStatus, index, !this.childPartOrdersOpenStatus[index])
    },
    /**
     * @description 單一訂單的細節開啟關閉
     */
    changeOpenStatus(item, index) {
      this.$set(item, index, !item[index])
    },
    /**
     * @description 單一訂單的細節開啟關閉
     */
    changeOpenStatusForChild(item, containerIndex, orderIndex) {
      this.$set(item[containerIndex], orderIndex, !item[containerIndex][orderIndex])
    },
    /**
     * @description 多筆之單一筆訂單中的加價購
     */
    singleOrderOfParams(index) {
      if (this.showServiceAll) {
        let result = []
        this.containerOrders['orders'].forEach((item) => {
          // 在觀看一般預約時，不可以顯示儲值金的抵扣（因為會放在總訂單那邊）
          result.push(item.params.filter(({ type }) => type !== 'deposit' && this[`${this.orderType}Types`].includes(type)))
        })
        return result[index]
      }
    },
    /**
     * @description 多筆中的單筆加總
     */
    singleOrderOfServiceTotal(index) {
      let total = 0
      if (this.prepaidDeductItem[index].priceId) {
        total = 0
      } else if (this.couponItem[index].priceId) {
        total = this.serviceItem[index].total + this.couponItem[index].total
      } else {
        total = this.serviceItem[index].total
      }
      return total
    },
    findItemByType(itemType = '') {
      if (this.showServiceAll) {
        let result = []
        this.containerOrders['orders'].forEach((item) => {
          result.push(item.params.find(({ type }) => type === itemType) || {})
        })
        return result
      } else {
        return this.defaultValue.params.find(({ type }) => type === itemType) || {}
      }
    },
    formatParamTitle(paramItem) {
      const paramType = paramItem.type
      const note = paramItem.title ? `<br/>(${paramItem.title})` : ''

      switch (paramType) {
        case 'cosmetic-add':
          return `加購「${paramItem.title}」`
        case '+':
          return `加價${note}`
        case '-':
          return `減價${note}`
        case '%':
          return `折扣${note}`
        case 'express':
          return `運費${note}`
        default:
          return paramItem.title
      }
    },
    formatParamPrice(paramItem) {
      const paramType = paramItem.type
      switch (paramType) {
        case '+':
          return `+ ${paramItem.price}`
        case '-':
        case 'deposit':
          return `- ${paramItem.price}`
        case '%':
          return `- ${paramItem.discount}`
        default:
          return paramItem.price
      }
    },
    formattedSpecs(specs) {
      return specs.map((spec) => `${spec.title}: ${spec.values[0].title}`).join(' | ')
    },

    openAddEdit() {
      this.$emit('openAdd')
    },
    openTotalEdit() {
      this.$emit('openTotalEdit')
    },
    /**
     * @description 編輯價格與折扣點下去
     */
    editOpenTotalEdit(index) {
      this.$emit('editOpenTotalEdit', index)
    },
    /**
     * @description 編輯付款方式點下去
     */
    editOpenPaymentMethod(index) {
      this.$emit('editOpenPaymentMethod', index)
    },
    /**
     * @description 訂單變更紀錄
     */
    editOpenHistory(index) {
      this.$emit('editOpenHistory', index)
    },
    /**
     * @description 取消or刪除訂單
     */
    tryToCancelOrder(index) {
      this.$emit('tryToCancelOrder', index)
    },
    /**
     * @description 退款點下去（從TotalStatementDetailDropDown.vue 來的）
     */
    editOpenRefund(index) {
      this.$emit('editOpenRefund', index)
    },
    /**
     * @description 客戶使用歷程
     */
    openDeductHistory(index) {
      this.$emit('openDeductHistory', index)
    },
    openNoteEdit() {
      this.$emit('noteEdit')
    },
    handleCommand(command) {
      this[command.command](command.index)
    },
    orderTitle(item, type = '') {
      if (this.orderType === 'prepaid') return `訂單 ${item.orderNo}`
      return type === 'isChildren' ? `子訂單 ${item.id}` : `訂單 ${item.id}`
    },
    isPaid(item) {
      if (this.orderType === 'prepaid') return item.status === 1
      return item.paymentStatus === 'PAID'
    },
    changeIsActiveItem(index) {
      const deleteCity = this.isActiveItem.indexOf(index)
      if (deleteCity > -1) {
        this.isActiveItem.splice(deleteCity, 1)
      } else {
        this.isActiveItem.push(index)
      }
    },
    modifyOrder() {
      this.$emit('modifyOrder')
      this.$store.commit('modifyOrder/GET_ORDER_INFO', this.defaultValue)
      this.$store.commit('modifyOrder/GET_MEMBER_INFO', this.memberInfo)
    },
  },
}
</script>
<template>
  <div :class="$style.wrapper">
    <div :class="$style.table">
      <div :class="$style.table__topTitle">
        <h6 :class="{ mobileHidden: isEmployee }">{{ forOrderTextShow }}</h6>
        <el-button v-if="orderType === 'reservation'" class="rounded" :class="{ [$style.seeAllOrdersIng]: showServiceAll }" @click="emitShowAll">{{ allOrderOrSingleOrderBtnText }}</el-button>
      </div>
      <div class="table__scroll mb-5">
        <!-- 預約方案 -->
        <!-- 單隻訂單顯示 -->
        <template v-if="orderType === 'reservation' && !showServiceAll">
          <div class="table__block" :class="{ 'd-md-block d-none': isEmployee }">
            <BaseCollapse style="margin-bottom: 15px" expanded is-table>
              <template v-slot:title>
                <TotalStatementDetailDropdown
                  :is-employee="isEmployee"
                  :order-type="orderType"
                  :default-value="submitData"
                  :item-index="'main'"
                  @editOpenTotalEdit="editOpenTotalEdit"
                  @editOpenPaymentMethod="editOpenPaymentMethod"
                  @editOpenHistory="editOpenHistory"
                  @tryToCancelOrder="tryToCancelOrder"
                  @editOpenRefund="editOpenRefund"
                  @modifyOrder="modifyOrder"
                />
              </template>
              <div class="table__content">
                <!-- 寵物名稱 -->
                <div class="table__orderInfo">
                  <div>
                    <div class="name">
                      <p
                        >{{ defaultValue.pet.name }} <span>- {{ serviceItem.title }}</span></p
                      >
                    </div>
                    <div class="dateTime">{{ defaultValue.date }} {{ defaultValue.time }}</div>
                  </div>
                  <div>
                    <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" :class="{ isOpenRotate: true }" />
                  </div>
                </div>
                <div class="table__head isEdit">
                  <div class="table__title"> 預約項目<span style="display:none">totalStatementDetail 1A</span></div>
                  <div class="table__item price"> 售價 </div>
                  <div class="table__item qty"> 數量 </div>
                  <div class="table__item count"> 小計 </div>
                </div>
                <!-- 單筆 - 主要服務項目 - 預約價錢顯示 -->
                <div v-if="multipleServicesList || serviceItem.priceId" class="table__box mb-3">
                  <div v-if="!multipleServicesList">
                    <div class="table__row">
                      <div class="table__title">{{ serviceItem.title }}</div>
                      <div class="table__item price">
                        <template v-if="serviceItem.levelDiscount > 0">
                          <span style="display:none">TotalStatementDetail A</span>會員價： {{ memberPrice(serviceItem) }}
                          <br />
                          <del class="line-through-price">售價：{{ serviceItem.price }}</del>
                        </template>
                        <template v-else>
                          {{ serviceItem.price }}
                        </template>
                      </div>
                      <div class="table__item qty">{{ `x${serviceItem.qty}` }}</div>
                      <div class="table__item count">{{ serviceItem.total }}</div>
                    </div>
                  </div>

                  <div v-if="multipleServicesList">
                    <div v-for="(service, index) in multipleServicesList" :key="service.id" class="table__row" :class="{ 'border-0': index !== multipleServicesList.length - 1 }">
                      <div class="table__title">{{ service.type === 'coupon' ? `優惠券 (${service.title})` : service.title }}</div>
                      <div class="table__item price">
                        <template v-if="service.levelDiscount > 0">
                          <span style="display:none">TotalStatementDetail A</span>會員價： {{ memberPrice(service) }}
                          <br />
                          <del class="line-through-price">售價：{{ service.price }}</del>
                        </template>
                        <template v-else>
                          {{ service.type === 'coupon' ? '' : service.price }}
                        </template>
                      </div>
                      <div class="table__item qty">{{ service.type === 'coupon' ? '' : `x${service.qty}` }}</div>
                      <div class="table__item count">{{ service.total }}</div>
                    </div>
                  </div>

                  <div v-if="prepaidDeductItem.priceId" class="table__row">
                    <div class="table__title">{{ prepaidDeductItem.title }}</div>
                    <div class="table__single">{{ prepaidDeductItem.total }}</div>
                  </div>

                  <!-- <div v-if="couponItem.priceId" class="table__row">
                    <div class="table__title">{{ `優惠券 (${couponItem.title})` }}</div>
                    <div class="table__single">{{ couponItem.total }}</div>
                  </div> -->

                  <div class="table__row">
                    <div class="table__title">小計</div>
                    <div class="table__single">{{ serviceTotal }}</div>
                  </div>
                </div>
                <!-- 單筆 母訂單下的加購項目 - 預約價錢顯示 -->
                <template v-if="params.length > 0">
                  <div class="table__box">
                    <div v-for="item in params" :key="item.id" class="table__row">
                      <div class="table__title">
                        <span v-html="formatParamTitle(item)"></span>
                      </div>
                      <div class="table__item price">
                        <span v-if="item.type === 'cosmetic-add'">
                          <template v-if="item.levelDiscount > 0">
                            <span style="display:none">TotalStatementDetail B</span>會員價： {{ memberPrice(item) }}
                            <br />
                            <del class="line-through-price">售價：{{ item.price }}</del>
                          </template>
                          <template v-else>
                            {{ item.price }}
                          </template>
                        </span>
                        <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                        <span v-else>{{ item.price }} </span>
                      </div>
                      <div class="table__item qty">x{{ item.qty }}</div>
                      <div class="table__item count">{{ item.total }}</div>
                    </div>
                  </div>
                </template>

                <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                  <div class="table__row">
                    <div class="table__title" style="width:50%"><span style="display:none">TotalStatementDetail 2A</span>應付金額</div>
                    <div class="table__single" style="width:40%">{{ submitData.payTotal }}</div>
                  </div>
                  <template v-if="submitData.refundHistories && submitData.refundHistories.length > 0">
                    <div v-for="(item, index) in submitData.refundHistories" :key="index" class="table__row">
                      <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                      <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%">-{{ item.Amt }}</div>
                      <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }}</div>
                    </div>
                  </template>
                </div>
              </div>
              <BaseCollapse title="付款資訊">
                <TotalStatementDetailSectionPayment :default-value="submitData" :installment-data="installmentData" />
              </BaseCollapse>
              <BaseCollapse title="使用人備註">
                <div class="p-3">
                  <div class="inline-between mb-2">
                    <div style="font-weight: 500; margin-bottom: 10px">使用人資訊</div>
                    <el-button type="text" style="padding-top: 0" size="mini" @click="openNoteEdit"> <BaseIcon name="edit" class="text-primary mr-2" />編輯備註 </el-button>
                  </div>
                  <ul class="userInfo">
                    <li class="mb-2">{{ defaultValue.fullName }} {{ defaultValue.gender | genderFilter }}</li>
                    <li class="mb-2">{{ `${defaultValue.phoneCode} ${defaultValue.phoneNumber}` }}</li>
                    <!-- <li>{{ defaultValue.member.email }}</li>
                                                                                                    <li v-if="defaultValue.member.lineId">LINE ID: {{ defaultValue.member.lineId }}</li> -->
                    <li class="mb-2" style="display: block">使用人備註：{{ defaultValue.note || '目前尚無備註' }}</li>
                  </ul>
                  <div v-if="!isEmptyByOrderExtrafields" class="byOrderExtrafieldsInfo">
                    <ul v-for="(byOrderExtrafield, byOrderExtrafieldIndex) in defaultValue.byOrderExtrafields" :key="`byOrderExtrafieldIndex-${byOrderExtrafieldIndex}`" :class="$style.question">
                      <li class="title">{{ byOrderExtrafield.title }}：</li>
                      <li v-if="byOrderExtrafield.value" class="value">{{ byOrderExtrafield.value }}</li>
                    </ul>
                  </div>
                </div>
              </BaseCollapse>
            </BaseCollapse>

            <BaseCollapse v-for="(addOrder, index) in childrenOrders" :key="addOrder.id" style="margin-bottom: 30px" is-table>
              <template v-slot:title>
                <TotalStatementDetailDropdown
                  :is-employee="isEmployee"
                  is-children
                  :order-type="orderType"
                  :default-value="addOrder"
                  :item-index="index"
                  @editOpenTotalEdit="editOpenTotalEdit"
                  @editOpenPaymentMethod="editOpenPaymentMethod"
                  @editOpenHistory="editOpenHistory"
                  @tryToCancelOrder="tryToCancelOrder"
                  @editOpenRefund="editOpenRefund"
                />
              </template>
              <div class="table__content">
                <div>
                  <div class="table__head isEdit">
                    <div class="table__title"><span style="display:none">TotalStatementDetail ad1</span> 加購項目 </div>
                    <div class="table__item price"> 售價 </div>
                    <div class="table__item qty"> 數量 </div>
                    <div class="table__item count"> 小計 </div>
                  </div>
                </div>

                <template v-if="addOrder.params.length > 0">
                  <div class="table__box">
                    <div v-for="item in addOrder.params" :key="item.id" class="table__row">
                      <div class="table__title">
                        <span v-html="formatParamTitle(item)"></span>
                      </div>
                      <div class="table__item price">
                        <span v-if="item.type === 'cosmetic-add'">
                          <template v-if="isChildOrdersHasLevel(item)">
                            <span style="display:none">TotalStatementDetail C</span>會員價： {{ memberPrice(item) }}
                            <br />
                            <del class="line-through-price">售價：{{ item.price }}</del>
                          </template>
                          <template v-else>
                            {{ item.price }}
                          </template>
                        </span>
                        <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                        <span v-else>{{ item.total }} </span>
                      </div>
                      <div class="table__item qty">{{ item.qty }}</div>
                      <div class="table__item count">{{ item.total }}</div>
                    </div>
                  </div>
                </template>

                <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                  <div class="table__row">
                    <div class="table__title" style="width:50%"
                      ><span style="display:none">TotalStatementDetail 2B</span>
                      應付金額
                    </div>
                    <div class="table__single" style="width:40%">
                      {{ addOrder.payTotal }}
                    </div>
                  </div>
                  <template v-if="addOrder.refundHistories.length > 0">
                    <div v-for="(item, i) in addOrder.refundHistories" :key="i" class="table__row">
                      <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                      <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%">-{{ item.Amt }}</div>
                      <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }}</div>
                    </div>
                  </template>
                </div>
              </div>
              <BaseCollapse title="付款資訊" small-title>
                <TotalStatementDetailSectionPayment :default-value="addOrder" />
              </BaseCollapse>
            </BaseCollapse>
          </div>

          <!-- Mobile Style -->
          <div class="table__block isStyleMobile" :class="{ isStyleIsEmployee: isEmployee }">
            <div class="table__blockInner" :class="{ isStyleIsEmployee: isEmployee }" style="margin-bottom: 15px">
              <div class="table__blockTitle">
                <span class="mr-1 ml-0">{{ orderTitle(submitData) }}</span>
                <template v-if="submitData.status === 0">
                  <BaseStateLabel state="info" text>
                    <span style="font-size:12px">{{ submitData.status | bookingStatusFilter('text') }}</span>
                  </BaseStateLabel>
                </template>
                <template v-else>
                  <template v-if="orderType === 'reservation'">
                    <BaseStateLabel :state="submitData.paymentStatus | paymentStatusMapFilter('color')" text>
                      <span style="font-size:12px">{{ submitData.paymentStatus | paymentStatusMapFilter('text') }}</span>
                    </BaseStateLabel>
                  </template>
                </template>
                <div class="mt-1">
                  應付金額：<span class="text-secondary">{{ submitData.payTotal }}</span>
                </div>
              </div>
              <div class="table__content" :class="{ isActive: isActiveItem.includes('main'), isStyleIsEmployee: isEmployee }">
                <div class="table__contentInner mt-2" :class="{ isStyleIsEmployee: isEmployee }">
                  <div class="table__head isEdit">
                    <div class="table__title"> 預約項目<span style="display:none">totalStatementDetail 1B</span></div>
                    <div class="table__item price"> 售價 </div>
                    <div class="table__item qty"> 數量 </div>
                    <div class="table__item count"> 小計 </div>
                  </div>

                  <div v-if="multipleServices || serviceItem.priceId" class="table__box mb-3">
                    <div v-if="!multipleServices">
                      <div class="table__row">
                        <div class="table__title">{{ serviceItem.title }}</div>
                        <div class="table__item price">
                          <template v-if="serviceItem.levelDiscount > 0">
                            <span style="display:none">TotalStatementDetail D</span>會員價： {{ memberPrice(serviceItem) }}
                            <br />
                            <del class="line-through-price">售價：{{ serviceItem.price }}</del>
                          </template>
                          <template v-else>
                            {{ serviceItem.price }}
                          </template>
                        </div>
                        <div class="table__item qty">{{ `x${serviceItem.qty}` }}</div>
                        <div class="table__item count">{{ serviceItem.total }}</div>
                      </div>
                    </div>
                    <div v-if="multipleServices">
                      <div v-for="(service, index) in multipleServices" :key="service.id" class="table__row" :class="{ 'border-0': index !== multipleServices.length - 1 }">
                        <div class="table__title">{{ service.title }}</div>
                        <div class="table__item price">
                          <template v-if="service.levelDiscount > 0">
                            <span style="display:none">TotalStatementDetail D</span>會員價： {{ memberPrice(service) }}
                            <br />
                            <del class="line-through-price">售價：{{ service.price }}</del>
                          </template>
                          <template v-else>
                            {{ service.price }}
                          </template>
                        </div>
                        <div class="table__item qty">{{ `x${service.qty}` }}</div>
                        <div class="table__item count">{{ service.total }}</div>
                      </div>
                    </div>
                    <div v-if="prepaidDeductItem.priceId" class="table__row">
                      <div class="table__title">{{ prepaidDeductItem.title }}</div>
                      <div class="table__single">{{ prepaidDeductItem.total }}</div>
                    </div>

                    <div v-if="couponItem.priceId" class="table__row">
                      <div class="table__title">{{ `優惠券 (${couponItem.title})` }}</div>
                      <div class="table__single">{{ couponItem.total }}</div>
                    </div>

                    <div class="table__row">
                      <div class="table__title">小計</div>
                      <div class="table__single">{{ serviceTotal }}</div>
                    </div>
                  </div>

                  <template v-if="params.length > 0">
                    <div class="table__box">
                      <div v-for="item in params" :key="item.id" class="table__row">
                        <div class="table__title">
                          <span v-html="formatParamTitle(item)"></span>
                        </div>
                        <div class="table__item price">
                          <span v-if="item.type === 'cosmetic-add'">
                            <template v-if="item.levelDiscount > 0">
                              <span style="display:none">TotalStatementDetail E</span>會員價： {{ memberPrice(item) }}
                              <br />
                              <del class="line-through-price">售價：{{ item.price }}</del>
                            </template>
                            <template v-else>
                              {{ item.total }}
                            </template>
                          </span>
                          <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                          <span v-else>{{ item.total }} </span>
                        </div>
                        <div class="table__item qty">{{ 'x1' }}</div>
                        <div class="table__item count">{{ item.total }}</div>
                      </div>
                    </div>
                  </template>

                  <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                    <div class="table__row">
                      <div class="table__title" style="width:50%"><span style="display:none">TotalStatementDetail 2C</span>應付金額</div>
                      <div class="table__single" style="width:40%">{{ submitData.payTotal }}</div>
                    </div>
                    <template v-if="submitData.refundHistories && submitData.refundHistories.length > 0">
                      <div v-for="(item, index) in submitData.refundHistories" :key="index" class="table__row">
                        <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                        <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%"> -{{ item.Amt }}</div>
                        <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }} </div>
                      </div>
                    </template>
                  </div>
                </div>
                <BaseCollapse title="付款資訊">
                  <TotalStatementDetailSectionPayment :default-value="submitData" :installment-data="installmentData" />
                </BaseCollapse>
              </div>
              <div class="d-flex mt-3 table__btn">
                <el-button class="is-round w-100 mr-1" @click="changeIsActiveItem('main')">{{ isActiveItem.includes('main') ? '隱藏' : '顯示' }}訂單資訊</el-button>
                <el-dropdown ref="more" trigger="click" :hide-on-click="true" @command="handleCommand">
                  <div>
                    <el-button class="is-round w-100 ml-1"> <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" />更多功能 </el-button>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <!-- Employee -->
                    <template v-if="orderType === 'reservation' && isEmployee">
                      <el-dropdown-item v-if="submitData.status !== 0 && !isPaid(submitData)" :command="{ command: 'editOpenTotalEdit', index: 'main' }">編輯加購</el-dropdown-item>
                      <el-dropdown-item :command="{ command: 'editOpenHistory', index: 'main' }">訂單變更記錄</el-dropdown-item>
                      <el-dropdown-item v-if="submitData.status !== 0 && submitData.status !== 6 && isChildren" :command="{ command: 'tryToCancelOrder', index: 'main' }">取消訂單</el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <div v-for="(addOrder, index) in childrenOrders" :key="addOrder.id" class="table__blockInner" style="margin-bottom: 30px" :class="{ isStyleIsEmployee: isEmployee }">
              <div class="table__blockTitle">
                <span class="mr-1 ml-0">{{ orderTitle(addOrder, 'isChildren') }}</span>
                <template v-if="addOrder.status === 0">
                  <BaseStateLabel state="info" text>
                    <span style="font-size:12px">{{ addOrder.status | bookingStatusFilter('text') }}</span>
                  </BaseStateLabel>
                </template>
                <template v-else>
                  <template v-if="orderType === 'reservation'">
                    <BaseStateLabel :state="addOrder.paymentStatus | paymentStatusMapFilter('color')" text>
                      <span style="font-size:12px">{{ addOrder.paymentStatus | paymentStatusMapFilter('text') }}</span>
                    </BaseStateLabel>
                  </template>
                </template>
                <div class="mt-1">
                  應付金額：<span class="text-secondary">{{ addOrder.payTotal }}</span>
                </div>
              </div>
              <div class="table__content" :class="{ isActive: isActiveItem.includes(index), isStyleIsEmployee: isEmployee }">
                <div class="table__contentInner mt-2" :class="{ isStyleIsEmployee: isEmployee }">
                  <div>
                    <div class="table__head isEdit">
                      <div class="table__title"> <span style="display:none">TotalStatementDetail ad2</span>加購項目 </div>
                      <div class="table__item price"> 售價 </div>
                      <div class="table__item qty"> 數量 </div>
                      <div class="table__item count"> 小計 </div>
                    </div>
                  </div>

                  <template v-if="addOrder.params.length > 0">
                    <div class="table__box">
                      <div v-for="item in addOrder.params" :key="item.id" class="table__row">
                        <div class="table__title">
                          <span v-html="formatParamTitle(item)"></span>
                        </div>
                        <div class="table__item price">
                          <span v-if="item.type === 'cosmetic-add'">
                            <template v-if="serviceItem.levelDiscount > 0">
                              <span style="display:none">TotalStatementDetail F</span>會員價： {{ memberPrice(item) }}
                              <br />
                              <del class="line-through-price">售價：{{ item.price }}</del>
                            </template>
                            <template v-else>
                              {{ item.price }}
                            </template>
                          </span>
                          <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                          <span v-else>{{ item.total }} </span>
                        </div>
                        <div class="table__item qty">{{ 'x1' }}</div>
                        <div class="table__item count">{{ item.total }}</div>
                      </div>
                    </div>
                  </template>

                  <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                    <div class="table__row">
                      <div class="table__title" style="width:50%"
                        ><span style="display:none">TotalStatementDetail 2D</span>
                        應付金額
                      </div>
                      <div class="table__single" style="width:40%">
                        {{ addOrder.payTotal }}
                      </div>
                    </div>
                    <template v-if="addOrder.refundHistories.length > 0">
                      <div v-for="(item, i) in addOrder.refundHistories" :key="i" class="table__row">
                        <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                        <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%"> -{{ item.Amt }}</div>
                        <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }} </div>
                      </div>
                    </template>
                  </div>
                </div>
                <BaseCollapse title="付款資訊" small-title>
                  <TotalStatementDetailSectionPayment :default-value="addOrder" />
                </BaseCollapse>
              </div>
              <div class="d-flex mt-3 table__btn">
                <el-button class="is-round w-100 mr-1" @click="changeIsActiveItem(index)">{{ isActiveItem.includes(index) ? '隱藏' : '顯示' }}訂單資訊</el-button>
                <el-dropdown ref="more" trigger="click" :hide-on-click="true" @command="handleCommand">
                  <div>
                    <el-button class="is-round w-100 ml-1"> <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" />更多功能 </el-button>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <!-- Employee -->
                    <template v-if="orderType === 'reservation' && isEmployee">
                      <el-dropdown-item v-if="addOrder.status !== 0 && !isPaid(addOrder)" :command="{ command: 'editOpenTotalEdit', index: index }">編輯加購</el-dropdown-item>
                      <el-dropdown-item v-if="addOrder.status !== 0 && !isPaid(addOrder)" :command="{ command: 'editOpenPaymentMethod', index: index }">編輯付款方式</el-dropdown-item>
                      <el-dropdown-item :command="{ command: 'editOpenHistory', index: index }">訂單變更記錄</el-dropdown-item>
                      <el-dropdown-item v-if="addOrder.status !== 0 && addOrder.status !== 6" :command="{ command: 'tryToCancelOrder', index: index }">取消訂單</el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </template>

        <!-- 多訂單顯示 -->
        <template v-if="orderType === 'reservation' && showServiceAll">
          <!-- parentContainer迴圈 -->
          <template v-for="(parentOrdersItem, parentOrdersIndex) in testAllOrders['orders']">
            <div :key="`${parentOrdersItem.id}-desktop`" class="table__block" :class="{ 'd-md-block d-none': isEmployee }">
              <BaseCollapse style="margin-bottom: 15px" expanded is-table>
                <template v-if="parentOrdersIndex === 0" v-slot:title>
                  <TotalStatementDetailDropdown
                    :show-cancel-or-delete-btn="parentOrdersItem.paymentStatus !== 'UNPAID'"
                    :order-type="orderType"
                    :default-value="testAllOrders"
                    :show-all="true"
                    :item-index="'main'"
                    @editOpenTotalEdit="editOpenTotalEdit"
                    @editOpenPaymentMethod="editOpenPaymentMethod"
                    @editOpenHistory="editOpenHistory"
                    @tryToCancelOrder="tryToCancelOrder"
                    @emitContainerId="emitContainerId(testAllOrders)"
                    @editOpenRefund="editOpenRefund"
                    @clickDropDownIcon="clickDropDownIcon('parent')"
                  />
                </template>
                <div v-if="parentPartOrdersOpenStatus" class="table__content bcc">
                  <!-- 寵物名稱 -->
                  <div class="table__orderInfo" @click.stop="changeOpenStatus(parentOpenStatus, parentOrdersIndex)">
                    <div>
                      <div class="name">
                        <p
                          >{{ parentOrdersItem.pet.name }}<span>- {{ serviceItem[parentOrdersIndex].title }}</span></p
                        >
                      </div>
                      <div class="stateLabel"> </div>
                      <div class="dateTime">{{ parentOrdersItem.date }} {{ parentOrdersItem.time }}</div>
                    </div>
                    <div>
                      <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" :class="{ isOpenRotate: parentOpenStatus[parentOrdersIndex] === true }" />
                    </div>
                  </div>
                  <!-- 表格title -->
                  <div v-if="parentOpenStatus[parentOrdersIndex]" class="table__AllHead isEdit">
                    <div class="table__title"> 預約項目<span style="display:none">totalStatementDetail 1C</span></div>
                    <div class="table__item price"> 售價 </div>
                    <div class="table__item qty"> 數量 </div>
                    <div class="table__item count"> 小計 </div>
                  </div>
                  <template v-if="parentOpenStatus[parentOrdersIndex]">
                    <div v-if="serviceItem[parentOrdersIndex].priceId" class="table__box">
                      <template>
                        <div v-if="multipleServices">
                          <div v-for="service in multipleServices" :key="service.id" class="table__row">
                            <div class="table__title">{{ service.title }}</div>
                            <div class="table__item price">
                              <template v-if="service.levelDiscount > 0">
                                <span style="display:none">TotalStatementDetail G</span>會員價： {{ memberPrice(service) }}
                                <br />
                                <del class="line-through-price">售價：{{ service.price }}</del>
                              </template>
                              <template v-else>
                                {{ service.price }}
                              </template>
                            </div>
                            <div class="table__item qty">{{ `x${service.qty}` }}</div>
                            <div class="table__item count">{{ service.total }}</div>
                          </div>
                        </div>
                        <div v-if="!multipleServices" class="table__row">
                          <div class="table__title">{{ serviceItem[parentOrdersIndex].title }}</div>
                          <div class="table__item price">
                            <template v-if="serviceItem[parentOrdersIndex].levelDiscount > 0">
                              <span style="display:none">TotalStatementDetail G</span>會員價： {{ memberPrice(serviceItem[parentOrdersIndex]) }}
                              <br />
                              <del class="line-through-price">售價：{{ serviceItem[parentOrdersIndex].price }}</del>
                            </template>
                            <template v-else>
                              {{ serviceItem[parentOrdersIndex].price }}
                            </template>
                          </div>
                          <div class="table__item qty">{{ `x${serviceItem[parentOrdersIndex].qty}` }}</div>
                          <div class="table__item count">{{ serviceItem[parentOrdersIndex].total }}</div>
                        </div>

                        <div v-if="prepaidDeductItem.priceId" class="table__row">
                          <div class="table__title">{{ prepaidDeductItem[parentOrdersIndex].title }}</div>
                          <div class="table__single">{{ prepaidDeductItem[parentOrdersIndex].total }}</div>
                        </div>

                        <div v-if="couponItem[parentOrdersIndex].priceId" class="table__row">
                          <div class="table__title">{{ `優惠券 (${couponItem[parentOrdersIndex].title})` }}</div>
                          <div class="table__single">{{ couponItem[parentOrdersIndex].total }}</div>
                        </div>
                        <template v-if="singleOrderOfParams(parentOrdersIndex).length > 0">
                          <div class="table__box table__moreBorder">
                            <div v-for="addItem in singleOrderOfParams(parentOrdersIndex)" :key="addItem.id" class="table__row">
                              <div class="table__title aa">
                                <span v-html="formatParamTitle(addItem)"></span>
                              </div>
                              <div class="table__item price">
                                <span v-if="addItem.type === 'cosmetic-add'">
                                  <template v-if="addItem.levelDiscount > 0">
                                    <span style="display:none">TotalStatementDetail H</span>會員價： {{ memberPrice(addItem) }}
                                    <br />
                                    <del class="line-through-price">售價：{{ addItem.price }}</del>
                                  </template>
                                  <template v-else>
                                    {{ addItem.price }}
                                  </template>
                                </span>
                                <span v-else-if="addItem.type === '%'">{{ `${addItem.description} %` }}</span>
                                <span v-else>{{ addItem.total }} </span>
                              </div>
                              <div class="table__item qty">{{ 'x1' }}</div>
                              <div class="table__item count">{{ addItem.total }}</div>
                            </div>
                          </div>
                        </template>
                      </template>
                    </div>
                  </template>
                  <div class="table__row table__bgWhite bga" @click.stop="">
                    <div class="table__title">小計</div>
                    <div class="table__single">{{ composeNoDepositPrice(parentOrdersItem) }}</div>
                  </div>
                  <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                    <template v-if="testAllOrders.refundHistories && testAllOrders.refundHistories.length > 0 && parentOrdersIndex === testAllOrders['orders'].length - 1">
                      <div v-for="(item, index) in testAllOrders.refundHistories" :key="index" class="table__row">
                        <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                        <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%"> -{{ item.Amt }}</div>
                        <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }} </div>
                      </div>
                    </template>
                  </div>
                </div>
              </BaseCollapse>
            </div>
            <!-- Mobile Style -->
            <div :key="`${parentOrdersItem.id}-mobile`" class="table__block isStyleMobile" :class="{ isStyleIsEmployee: isEmployee }">
              <div class="table__blockInner" :class="{ isStyleIsEmployee: isEmployee }" style="margin-bottom: 15px">
                <div class="table__blockTitle">
                  <span class="mr-1 ml-0">{{ orderTitle(submitData) }}</span>
                  <template v-if="submitData.status === 0">
                    <BaseStateLabel state="info" text>
                      <span style="font-size:12px">{{ submitData.status | bookingStatusFilter('text') }}</span>
                    </BaseStateLabel>
                  </template>
                  <template v-else>
                    <template v-if="orderType === 'reservation'">
                      <BaseStateLabel :state="submitData.paymentStatus | paymentStatusMapFilter('color')" text>
                        <span style="font-size:12px">{{ submitData.paymentStatus | paymentStatusMapFilter('text') }}</span>
                      </BaseStateLabel>
                    </template>
                  </template>
                  <div class="mt-1">
                    應付金額：<span class="text-secondary">{{ submitData.payTotal }}</span>
                  </div>
                </div>
                <div class="table__content" :class="{ isActive: isActiveItem.includes('main'), isStyleIsEmployee: isEmployee }">
                  <div class="table__contentInner mt-2" :class="{ isStyleIsEmployee: isEmployee }">
                    <div class="table__head isEdit">
                      <div class="table__title"> 預約項目<span style="display:none">totalStatementDetail 1D</span></div>
                      <div class="table__item price"> 售價 </div>
                      <div class="table__item qty"> 數量 </div>
                      <div class="table__item count"> 小計 </div>
                    </div>

                    <div v-if="serviceItem.priceId" class="table__box mb-3">
                      <div class="table__row">
                        <div class="table__title">{{ item.serviceItem.title }}</div>
                        <div class="table__item price">
                          <template v-if="serviceItem.levelDiscount > 0">
                            <span style="display:none">TotalStatementDetail I</span>會員價： {{ memberPrice(serviceItem) }}
                            <br />
                            <del class="line-through-price">售價：{{ serviceItem.price }}</del>
                          </template>
                          <template v-else>
                            {{ serviceItem.price }}
                          </template>
                        </div>
                        <div class="table__item qty">{{ `x${serviceItem.qty}` }}</div>
                        <div class="table__item count">{{ serviceItem.total }}</div>
                      </div>

                      <div v-if="prepaidDeductItem.priceId" class="table__row">
                        <div class="table__title">{{ prepaidDeductItem[index].title }}</div>
                        <div class="table__single">{{ prepaidDeductItem[index].total }}</div>
                      </div>

                      <div v-if="couponItem.priceId" class="table__row">
                        <div class="table__title">{{ `優惠券 (${couponItem[index].title})` }}</div>
                        <div class="table__single">{{ couponItem[index].total }}</div>
                      </div>

                      <div class="table__row">
                        <div class="table__title">小計</div>
                        <div class="table__single">{{ serviceTotal }}</div>
                      </div>
                    </div>

                    <template v-if="params.length > 0">
                      <div class="table__box">
                        <div v-for="item in params" :key="item.id" class="table__row">
                          <div class="table__title bb">
                            <span v-html="formatParamTitle(item)"></span>
                          </div>
                          <div class="table__item price">
                            <span v-if="item.type === 'cosmetic-add'">
                              <template v-if="item.levelDiscount > 0">
                                <span style="display:none">TotalStatementDetail J</span>會員價： {{ memberPrice(item) }}
                                <br />
                                <del class="line-through-price">售價：{{ item.price }}</del>
                              </template>
                              <template v-else>
                                {{ item.price }}
                              </template>
                            </span>
                            <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                            <span v-else>{{ item.total }} </span>
                          </div>
                          <div class="table__item qty">{{ 'x1' }}</div>
                          <div class="table__item count">{{ item.total }}</div>
                        </div>
                      </div>
                    </template>

                    <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                      <div class="table__row">
                        <div class="table__title" style="width:50%"><span style="display:none">TotalStatementDetail 2E</span>應付金額</div>
                        <div class="table__single" style="width:40%">{{ submitData.payTotal }}</div>
                      </div>
                      <template v-if="testAllOrders.refundHistories && testAllOrders.refundHistories.length > 0">
                        <div v-for="(item, index) in testAllOrders.refundHistories" :key="index" class="table__row">
                          <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                          <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%">-{{ item.Amt }}</div>
                          <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }} </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <BaseCollapse title="付款資訊">
                    <TotalStatementDetailSectionPayment :default-value="submitData" :installment-data="installmentData" />
                  </BaseCollapse>
                </div>
                <div class="d-flex mt-3 table__btn">
                  <el-button class="is-round w-100 mr-1" @click="changeIsActiveItem('main')">{{ isActiveItem.includes('main') ? '隱藏' : '顯示' }}訂單資訊</el-button>
                  <el-dropdown ref="more" trigger="click" :hide-on-click="true" @command="handleCommand">
                    <div>
                      <el-button class="is-round w-100 ml-1"> <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" />更多功能 </el-button>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <!-- Employee -->
                      <template v-if="orderType === 'reservation' && isEmployee">
                        <el-dropdown-item v-if="submitData.status !== 0 && !isPaid(submitData)" :command="{ command: 'editOpenTotalEdit', index: 'main' }">編輯加購</el-dropdown-item>
                        <el-dropdown-item :command="{ command: 'editOpenHistory', index: 'main' }">訂單變更記錄</el-dropdown-item>
                        <el-dropdown-item v-if="submitData.status !== 0 && submitData.status !== 6 && isChildren" :command="{ command: 'tryToCancelOrder', index: 'main' }">取消訂單</el-dropdown-item>
                      </template>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <template v-if="false">
                <div v-for="(addOrder, index) in childrenOrders" :key="addOrder.id" class="table__blockInner" style="margin-bottom: 30px" :class="{ isStyleIsEmployee: isEmployee }">
                  <div class="table__blockTitle">
                    <span class="mr-1 ml-0">{{ orderTitle(addOrder, 'isChildren') }}</span>
                    <template v-if="addOrder.status === 0">
                      <BaseStateLabel state="info" text>
                        <span style="font-size:12px">{{ addOrder.status | bookingStatusFilter('text') }}</span>
                      </BaseStateLabel>
                    </template>
                    <template v-else>
                      <template v-if="orderType === 'reservation'">
                        <BaseStateLabel :state="addOrder.paymentStatus | paymentStatusMapFilter('color')" text>
                          <span style="font-size:12px">{{ addOrder.paymentStatus | paymentStatusMapFilter('text') }}</span>
                        </BaseStateLabel>
                      </template>
                    </template>
                    <div class="mt-1">
                      應付金額：<span class="text-secondary">{{ addOrder.payTotal }}</span>
                    </div>
                  </div>
                  <div class="table__content" :class="{ isActive: isActiveItem.includes(index), isStyleIsEmployee: isEmployee }">
                    <div class="table__contentInner mt-2" :class="{ isStyleIsEmployee: isEmployee }">
                      <div>
                        <div class="table__head isEdit">
                          <div class="table__title"> <span style="display:none">TotalStatementDetail ad3</span>加購項目</div>
                          <div class="table__item price"> 售價 </div>
                          <div class="table__item qty"> 數量 </div>
                          <div class="table__item count"> 小計 </div>
                        </div>
                      </div>

                      <template v-if="addOrder.params.length > 0">
                        <div class="table__box">
                          <div v-for="(item, i) in addOrder.params" :key="i" class="table__row">
                            <div class="table__title cc">
                              <span v-html="formatParamTitle(item)"></span>
                            </div>
                            <div class="table__item price">
                              <span v-if="item.type === 'cosmetic-add'">
                                <template v-if="serviceItem.levelDiscount > 0">
                                  <span style="display:none">TotalStatementDetail K</span>會員價： {{ memberPrice(item) }}
                                  <br />
                                  <del class="line-through-price">售價：{{ item.price }}</del>
                                </template>
                                <template v-else>
                                  {{ item.price }}
                                </template>
                              </span>
                              <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                              <span v-else>{{ item.total }} </span>
                            </div>
                            <div class="table__item qty">{{ 'x1' }}</div>
                            <div class="table__item count">{{ item.total }}</div>
                          </div>
                        </div>
                      </template>

                      <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                        <div class="table__row">
                          <div class="table__title" style="width:50%"
                            ><span style="display:none">TotalStatementDetail 2F</span>
                            應付金額
                          </div>
                          <div class="table__single" style="width:40%">
                            {{ addOrder.payTotal }}
                          </div>
                        </div>
                        <template v-if="addOrder.refundHistories.length > 0">
                          <div v-for="(item, i) in addOrder.refundHistories" :key="i" class="table__row">
                            <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                            <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%">-{{ item.Amt }}</div>
                            <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }} </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <BaseCollapse title="付款資訊" small-title>
                      <TotalStatementDetailSectionPayment :default-value="addOrder" />
                    </BaseCollapse>
                  </div>
                  <div class="d-flex mt-3 table__btn">
                    <el-button class="is-round w-100 mr-1" @click="changeIsActiveItem(index)">{{ isActiveItem.includes(index) ? '隱藏' : '顯示' }}訂單資訊</el-button>
                    <el-dropdown ref="more" trigger="click" :hide-on-click="true" @command="handleCommand">
                      <div>
                        <el-button class="is-round w-100 ml-1"> <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" />更多功能 </el-button>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <!-- Employee -->
                        <template v-if="orderType === 'reservation' && isEmployee">
                          <el-dropdown-item v-if="addOrder.status !== 0 && !isPaid(addOrder)" :command="{ command: 'editOpenTotalEdit', index: index }">編輯加購</el-dropdown-item>
                          <el-dropdown-item v-if="addOrder.status !== 0 && !isPaid(addOrder)" :command="{ command: 'editOpenPaymentMethod', index: index }">編輯付款方式</el-dropdown-item>
                          <el-dropdown-item :command="{ command: 'editOpenHistory', index: index }">訂單變更記錄</el-dropdown-item>
                          <el-dropdown-item v-if="addOrder.status !== 0 && addOrder.status !== 6" :command="{ command: 'tryToCancelOrder', index: index }">取消訂單</el-dropdown-item>
                          <!-- <el-dropdown-item v-if="isPaid && defaultValue.paymentMethod !== 'Prepaid'" command="editOpenRefund">退款</el-dropdown-item> -->
                        </template>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </template>
            </div>
          </template>
          <!-- parentContainer params 總訂單加購回圈 -->
          <BaseCollapse v-if="parentPartOrdersOpenStatus && testAllOrders.params && testAllOrders.params.length > 0" style="margin-bottom: 30px" expanded is-table>
            <div class="table__content">
              <template>
                <div>
                  <div class="table__AllHead isEdit">
                    <div class="table__title">總訂單加購項目</div>
                    <div class="table__item price"> 售價 </div>
                    <div class="table__item qty"> 數量 </div>
                    <div class="table__item count"> 小計 </div>
                  </div>
                </div>

                <template v-if="testAllOrders.params.length">
                  <div class="table__box">
                    <div v-for="(item, index) in testAllOrders.params" :key="index" class="table__row">
                      <div class="table__title dd">
                        <span v-html="formatParamTitle(item)"></span>
                      </div>
                      <div class="table__item price">
                        <span v-if="item.type === 'cosmetic-add'">
                          <template v-if="serviceItem.levelDiscount > 0">
                            <span style="display:none">TotalStatementDetail L</span>會員價： {{ memberPrice(item) }}
                            <br />
                            <del class="line-through-price">售價：{{ item.price }}</del>
                          </template>
                          <template v-else>
                            {{ item.price }}
                          </template>
                        </span>
                        <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                        <span v-else>{{ item.total }} </span>
                      </div>
                      <div class="table__item qty">{{ 'x1' }}</div>
                      <div class="table__item count">{{ item.total }}</div>
                    </div>
                  </div>
                </template>
              </template>
              <div class="table__row table__bgWhite bgb">
                <div class="table__title" style="width:50%">
                  小計
                </div>
                <div class="table__single" style="width:40%">
                  {{ testAllOrders.paramsTotal }}
                </div>
              </div>
            </div>
          </BaseCollapse>
          <NoteAndDetailSectionPayment v-if="Object.keys(testAllOrders).length > 0" :default-value="testAllOrders['orders'][0]" @openNoteEdit="openNoteEdit" />
          <!-- 發票資訊 -->
          <InvoiceInfoForShow :container-orders="containerOrders" style="margin-top: 26.25px;" order-type="reservation" />
          <!-- 子訂單迴圈 -->
          <div v-if="Object.keys(testAllOrders).length > 0">
            <div v-for="(childrenOuterContainer, childrenOuterContainerIndex) in testAllOrders['childrenOrderContainers']['items']" :key="`child-container-${childrenOuterContainerIndex}-${childrenOuterContainer.displayId}`">
              <div @click="openCloseOrdersForChild(childrenOuterContainerIndex)">
                <template v-if="childrenOuterContainer['orders'].length > 0">
                  <BaseCollapse style="margin-bottom: 30px;margin-top: 30px" expanded is-table>
                    <template v-slot:title>
                      <TotalStatementDetailDropdown
                        is-children
                        :order-type="orderType"
                        :show-all="true"
                        :show-cancel-or-delete-btn="showCancelOrDeleteFunc(childrenOuterContainer)"
                        :default-value="childrenOuterContainer['orders'][0]"
                        :item-index="childrenOuterContainerIndex"
                        @editOpenTotalEdit="editOpenTotalEdit"
                        @editOpenPaymentMethod="editOpenPaymentMethod"
                        @editOpenHistory="editOpenHistory"
                        @emitContainerId="emitContainerId(childrenOuterContainer)"
                        @tryToCancelOrder="tryToCancelOrder"
                        @editOpenRefund="editOpenRefund"
                      />
                    </template>
                    <!-- 子訂單內容 -->
                    <div v-for="(childOrderItem, childOrderIndex) in childrenOuterContainer['orders']" :key="childOrderItem.id">
                      <div class="table__content">
                        <!-- 寵物名稱 -->
                        <div class="table__orderInfo" @click.stop="changeOpenStatusForChild(childOpenStatus, childrenOuterContainerIndex, childOrderIndex)">
                          <div>
                            <div class="name">
                              <p
                                >{{ childOrderItem.pet.name }}<span>- {{ childOrderItem.serviceTitle }}</span></p
                              >
                            </div>
                            <div class="stateLabel"> </div>
                            <div class="dateTime">{{ childOrderItem.date }} {{ childOrderItem.time }} </div>
                          </div>
                          <div>
                            <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" :class="{ isOpenRotate: childOpenStatus[childrenOuterContainerIndex][childOrderIndex] === true }" />
                          </div>
                        </div>
                        <template v-if="childOpenStatus[childrenOuterContainerIndex][childOrderIndex]">
                          <div>
                            <div class="table__AllHead isEdit">
                              <div class="table__title"><span style="display:none">TotalStatementDetail ad4</span>加購項目 </div>
                              <div class="table__item price"> 售價 </div>
                              <div class="table__item qty"> 數量 </div>
                              <div class="table__item count"> 小計 </div>
                            </div>
                          </div>

                          <template v-if="childOrderItem.params.length > 0">
                            <div class="table__box">
                              <div v-for="paramsItem in childOrderItem.params" :key="paramsItem.id" class="table__row">
                                <div class="table__title ee">
                                  <span v-html="formatParamTitle(paramsItem)"></span>
                                </div>
                                <div class="table__item price">
                                  <span v-if="paramsItem.type === 'cosmetic-add'">
                                    <template v-if="paramsItem.levelDiscount > 0">
                                      <span style="display:none">TotalStatementDetail M</span>會員價： {{ memberPrice(paramsItem) }}
                                      <br />
                                      <del class="line-through-price">售價：{{ paramsItem.price }}</del>
                                    </template>
                                    <template v-else>
                                      {{ paramsItem.price }}
                                    </template>
                                  </span>
                                  <span v-else-if="paramsItem.type === '%'">{{ `${paramsItem.description} %` }}</span>
                                  <span v-else>{{ paramsItem.total }} </span>
                                </div>
                                <div class="table__item qty">{{ 'x1' }}</div>
                                <div class="table__item count">{{ paramsItem.total }}</div>
                              </div>
                            </div>
                          </template>
                        </template>
                        <div class="table__row table__bgWhite bgc">
                          <div class="table__title" style="width:50%">
                            小計
                          </div>
                          <div class="table__single" style="width:40%">
                            {{ childOrderItem.priceTotal }}
                          </div>
                        </div>

                        <div class="table__box" style="margin-bottom:10px">
                          <template
                            v-if="childrenOuterContainer.refundHistories && childrenOuterContainer.refundHistories.length > 0 && childOrderIndex === childrenOuterContainer['orders'].length - 1"
                          >
                            <div v-for="(item, index) in childrenOuterContainer.refundHistories" :key="index" class="table__row">
                              <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                              <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%"> -{{ item.Amt }}</div>
                              <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }} </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </BaseCollapse>
                </template>
              </div>
              <!-- 子container加購回圈 -->
              <BaseCollapse v-if="childPartOrdersOpenStatus[childrenOuterContainerIndex] && childrenOuterContainer.params.length" style="margin-bottom: 30px" expanded is-table>
                <div class="table__content">
                  <template>
                    <div>
                      <div class="table__AllHead isEdit">
                        <div class="table__title">總訂單加購項目</div>
                        <div class="table__item price"> 售價</div>
                        <div class="table__item qty"> 數量</div>
                        <div class="table__item count"> 小計 </div>
                      </div>
                    </div>

                    <template>
                      <div class="table__box">
                        <div v-for="item in childrenOuterContainer.params" :key="item.id" class="table__row">
                          <div class="table__title ff">
                            <span v-html="formatParamTitle(item)"></span>
                          </div>
                          <div class="table__item price">
                            <span v-if="item.type === 'cosmetic-add'">
                              <template v-if="item.levelDiscount > 0">
                                <span style="display:none">TotalStatementDetail N</span>會員價： {{ memberPrice(item) }}
                                <br />
                                <del class="line-through-price">售價：{{ item.price }}</del>
                              </template>
                              <template v-else>
                                {{ item.price }}
                              </template>
                            </span>
                            <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                            <span v-else>{{ item.total }} </span>
                          </div>
                          <div class="table__item qty">{{ 'x1' }}</div>
                          <div class="table__item count">{{ item.total }}</div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <div class="table__row table__bgWhite bgd">
                    <div class="table__title" style="width:50%">
                      小計
                    </div>
                    <div class="table__single" style="width:40%">
                      {{ childrenOuterContainer.paramsTotal }}
                    </div>
                  </div>
                </div>
              </BaseCollapse>
              <NoteAndDetailSectionPayment v-if="Object.keys(testAllOrders).length > 0" :default-value="childrenOuterContainer['orders'][0]" @openNoteEdit="openNoteEdit" />
              <!-- 發票資訊 -->
              <InvoiceInfoForShow :key="`invoice-${childrenOuterContainerIndex}`" :container-orders="childrenOuterContainer" style="margin-top: 26.25px;" order-type="reservation" />
            </div>
          </div>
        </template>

        <!-- 包月方案 -->
        <template v-if="orderType === 'prepaid'">
          <BaseCollapse style="margin-bottom: 30px" expanded is-table>
            <template v-slot:title>
              <TotalStatementDetailDropdown
                item-index="main"
                :order-type="orderType"
                :default-value="submitData"
                @editOpenTotalEdit="editOpenTotalEdit"
                @editOpenPaymentMethod="editOpenPaymentMethod"
                @editOpenHistory="editOpenHistory"
                @tryToCancelOrder="tryToCancelOrder"
                @editOpenRefund="editOpenRefund"
                @openDeductHistory="openDeductHistory"
              />
            </template>
            <div>
              <div class="table__head isEdit">
                <div class="table__title"> 項目 </div>
                <div class="table__item price"> 售價 </div>
                <div class="table__item qty"> 數量 </div>
                <div class="table__item count"> 小計 </div>
              </div>

              <div class="table__box mb-3">
                <div class="table__row">
                  <div class="table__title">{{ prepaidPlanItem.title }}</div>
                  <div class="table__item price">
                    <template v-if="prepaidPlanItem.levelDiscount > 0">
                      <span style="display:none">TotalStatementDetail O</span>會員價： {{ memberPrice(prepaidPlanItem) }}
                      <br />
                      <del class="line-through-price">售價：{{ prepaidPlanItem.price }}</del>
                    </template>
                    <template v-else>
                      {{ prepaidPlanItem.price }}
                    </template>
                  </div>
                  <div class="table__item qty">{{ `x${prepaidPlanItem.qty}` }}</div>
                  <div class="table__item count">{{ prepaidPlanItem.total }}</div>
                </div>

                <template v-if="params.length > 0">
                  <div v-for="item in params" :key="item.id" class="table__row">
                    <div class="table__title gg">
                      <span v-html="formatParamTitle(item)"></span>
                    </div>
                    <div class="table__item price">
                      <span v-if="item.type === '%'">{{ `${item.description} %` }}</span>
                      <span v-else>{{ item.total }} </span>
                    </div>
                    <div class="table__item qty">{{ 'x1' }}</div>
                    <div class="table__item count">{{ item.total }}</div>
                  </div>
                </template>
              </div>

              <div class="table__box" style="margin-top: 10px;margin-bottom: 10px">
                <div class="table__row">
                  <div class="table__title" style="width:50%"><span style="display:none">TotalStatementDetail 2G</span>應付金額</div>
                  <div class="table__single" style="width:40%">{{ submitData.priceTotal }}</div>
                </div>
                <template v-if="submitData.refundHistories && submitData.refundHistories.length > 0">
                  <div v-for="(item, index) in submitData.refundHistories" :key="index" class="table__row">
                    <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                    <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%">-{{ item.Amt }}</div>
                    <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }}</div>
                  </div>
                </template>
              </div>
            </div>
            <div style="padding: 14px 15px 0 15px" class="bg-white mb-4">
              <div class="Jost d-flex justify-content-between mb-3">
                <span class="text-secondary">購買項目可抵用次數</span>
                <span class="text-secondary">{{ `${submitData.times - submitData.used} / ${submitData.times}` }}</span>
              </div>
              <div v-if="submitData.bonusTimes" class="Jost d-flex justify-content-between mb-3">
                <span class="text-secondary">贈送項目可抵用次數</span>
                <span class="text-secondary">{{ `${submitData.bonusTimes - submitData.bonusUsed} / ${submitData.bonusTimes}` }}</span>
              </div>
              <div v-for="item in submitData.prices" :key="item.id" class="Jost d-flex justify-content-between">
                <p class="mt-0">{{ item.name }}</p>
                <p class="mt-0 pl-1 text-secondary">{{ `${item.maxTimes - item.used} / ${item.maxTimes}` }}</p>
              </div>
            </div>
            <BaseCollapse title="付款資訊">
              <TotalStatementDetailSectionPayment :default-value="submitData" :installment-data="installmentData" />
            </BaseCollapse>
          </BaseCollapse>
          <InvoiceInfoForShow :container-orders="submitData" style="margin-top: 26.25px;" order-type="prepaid" />
        </template>

        <!-- 儲值金 -->
        <template v-if="orderType === 'deposit'">
          <BaseCollapse style="margin-bottom: 30px" expanded is-table>
            <template v-slot:title>
              <TotalStatementDetailDropdown
                item-index="main"
                :order-type="orderType"
                :default-value="submitData"
                @editOpenPaymentMethod="editOpenPaymentMethod"
                @editOpenHistory="editOpenHistory"
                @tryToCancelOrder="tryToCancelOrder"
              />
            </template>
            <div>
              <div class="table__head isEdit">
                <div class="table__title"> 項目 </div>
                <div class="table__item count"> 點數 </div>
                <div class="table__item qty"> 數量 </div>
                <div class="table__item price"> 小計 </div>
              </div>

              <div class="table__box mb-3">
                <div class="table__row">
                  <div class="table__title">{{ depositPlanItem.title }}</div>
                  <div class="table__item count">{{ depositPlanItemPoint }}</div>
                  <div class="table__item qty">{{ `x${depositPlanItem.qty}` }}</div>
                  <div class="table__item price">
                    <template v-if="depositPlanItem.levelDiscount > 0">
                      <span style="display:none">TotalStatementDetail P</span>會員價： {{ memberPrice(depositPlanItem) }}
                      <br />
                      <del class="line-through-price">售價：{{ depositPlanItem.price }}</del>
                    </template>
                    <template v-else>
                      {{ depositPlanItem.price }}
                    </template>
                  </div>
                </div>
              </div>

              <div class="table__box" style="margin-top: 10px;margin-bottom: 10px">
                <div class="table__row">
                  <div class="table__title" style="width:50%"><span style="display:none">TotalStatementDetail 2H</span>應付金額</div>
                  <div class="table__single" style="width:40%">{{ submitData.priceTotal }}</div>
                </div>
              </div>
            </div>
            <BaseCollapse title="付款資訊">
              <TotalStatementDetailSectionPayment :default-value="submitData" :installment-data="installmentData" />
            </BaseCollapse>
          </BaseCollapse>
          <InvoiceInfoForShow :container-orders="submitData" style="margin-top: 26.25px;" order-type="deposit" />
        </template>

        <!-- 商品訂單 -->
        <template v-if="orderType === 'goods'">
          <div class="table__block" :class="{ 'd-md-block d-none': isEmployee }">
            <BaseCollapse style="margin-bottom: 15px" expanded is-table>
              <template v-slot:title>
                <TotalStatementDetailDropdown
                  :is-employee="isEmployee"
                  :refund-check="refundCheck"
                  :order-type="orderType"
                  :default-value="submitData"
                  :item-index="'main'"
                  @editOpenTotalEdit="editOpenTotalEdit"
                  @editOpenPaymentMethod="editOpenPaymentMethod"
                  @editOpenHistory="editOpenHistory"
                  @tryToCancelOrder="tryToCancelOrder"
                  @editOpenRefund="editOpenRefund"
                />
              </template>
              <div class="table__content">
                <div class="table__orderInfo">
                  <div>
                    <div class="name">
                      <p>商品購買</p>
                    </div>
                    <div class="dateTime">{{ defaultValue.date }} {{ defaultValue.time }}</div>
                  </div>
                  <div>
                    <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" :class="{ isOpenRotate: true }" />
                  </div>
                </div>
                <div class="table__head isEdit">
                  <div class="table__title"> 商品名稱<span style="display:none">totalStatementDetail 1A</span></div>
                  <div class="table__item price"> 售價 </div>
                  <div class="table__item qty"> 數量 </div>
                  <div class="table__item count"> 小計 </div>
                </div>
                <!-- 商品購買列表 -->
                <template v-if="params.length > 0">
                  <div class="table__box">
                    <div v-for="item in params" :key="item.id" class="table__row">
                      <div class="table__title">
                        <span v-html="formatParamTitle(item)"></span>
                        <p v-if="item.spec" class="my-1 text-info">
                          {{ formattedSpecs(item.spec) }}
                        </p>
                      </div>
                      <div class="table__item price">
                        <span v-if="item.type === 'cosmetic-add'">
                          <template v-if="item.levelDiscount > 0">
                            <span style="display:none">TotalStatementDetail B</span>會員價： {{ memberPrice(item) }}
                            <br />
                            <del class="line-through-price">售價：{{ item.price }}</del>
                          </template>
                          <template v-else>
                            {{ item.price }}
                          </template>
                        </span>
                        <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                        <span v-else>{{ item.price }} </span>
                      </div>
                      <div class="table__item qty">x{{ item.qty }}</div>
                      <div class="table__item count">{{ item.total }}</div>
                    </div>
                  </div>
                </template>

                <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                  <div class="table__row">
                    <div class="table__title" style="width:50%"><span style="display:none">TotalStatementDetail 2A</span>應付金額</div>
                    <div class="table__single" style="width:40%">{{ submitData.payTotal }}</div>
                  </div>
                  <template v-if="containerOrders.refundHistories && containerOrders.refundHistories.length > 0">
                    <div v-for="(item, index) in containerOrders.refundHistories" :key="index" class="table__row">
                      <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                      <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%">-{{ item.Amt }}</div>
                      <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }}</div>
                    </div>
                  </template>
                </div>
              </div>
              <BaseCollapse title="付款資訊">
                <TotalStatementDetailSectionPayment :default-value="submitData" :installment-data="installmentData" />
              </BaseCollapse>
              <BaseCollapse v-if="containerOrders.shippingInfo && Object.keys(containerOrders.shippingInfo).length" title="寄送地址">
                <div class="p-3">
                  <ul class="userInfo">
                    <li>姓名：{{ containerOrders.shippingInfo.name }}</li>
                    <li>地址：{{ `(${containerOrders.shippingInfo.postcode})${containerOrders.shippingInfo.city + containerOrders.shippingInfo.district}${containerOrders.shippingInfo.address}` }}</li>
                    <li>電話：{{ containerOrders.shippingInfo.phone }}</li>
                  </ul>
                </div>
              </BaseCollapse>
              <BaseCollapse title="使用人備註">
                <div class="p-3">
                  <div class="inline-between mb-2">
                    <div style="font-weight: 500; margin-bottom: 10px">使用人資訊</div>
                    <el-button type="text" style="padding-top: 0" size="mini" @click="openNoteEdit"> <BaseIcon name="edit" class="text-primary mr-2" />編輯備註 </el-button>
                  </div>
                  <ul class="userInfo">
                    <li class="mb-2">{{ defaultValue.fullName }} {{ defaultValue.gender | genderFilter }}</li>
                    <li class="mb-2">{{ `${defaultValue.phoneCode} ${defaultValue.phoneNumber}` }}</li>
                    <!-- <li>{{ defaultValue.member.email }}</li>
                    <li v-if="defaultValue.member.lineId">LINE ID: {{ defaultValue.member.lineId }}</li> -->
                    <li class="mb-2" style="display: block">使用人備註：{{ defaultValue.note || '目前尚無備註' }}</li>
                  </ul>
                </div>
              </BaseCollapse>
            </BaseCollapse>
          </div>

          <!-- Mobile Style -->
          <div class="table__block isStyleMobile" :class="{ isStyleIsEmployee: isEmployee }">
            <div class="table__blockInner" :class="{ isStyleIsEmployee: isEmployee }" style="margin-bottom: 15px">
              <div class="table__blockTitle">
                <span class="mr-1 ml-0">{{ orderTitle(submitData) }}</span>
                <template v-if="submitData.status === 0">
                  <BaseStateLabel state="info" text>
                    <span style="font-size:12px">{{ submitData.status | bookingStatusFilter('text') }}</span>
                  </BaseStateLabel>
                </template>
                <template v-else>
                  <template v-if="orderType === 'reservation'">
                    <BaseStateLabel :state="submitData.paymentStatus | paymentStatusMapFilter('color')" text>
                      <span style="font-size:12px">{{ submitData.paymentStatus | paymentStatusMapFilter('text') }}</span>
                    </BaseStateLabel>
                  </template>
                </template>
                <div class="mt-1">
                  應付金額：<span class="text-secondary">{{ submitData.payTotal }}</span>
                </div>
              </div>
              <div class="table__content" :class="{ isActive: isActiveItem.includes('main'), isStyleIsEmployee: isEmployee }">
                <div class="table__contentInner mt-2" :class="{ isStyleIsEmployee: isEmployee }">
                  <div class="table__head isEdit">
                    <div class="table__title"> 預約項目<span style="display:none">totalStatementDetail 1B</span></div>
                    <div class="table__item price"> 售價 </div>
                    <div class="table__item qty"> 數量 </div>
                    <div class="table__item count"> 小計 </div>
                  </div>

                  <div v-if="serviceItem.priceId" class="table__box mb-3">
                    <div class="table__row">
                      <div class="table__title">{{ serviceItem.title }}</div>
                      <div class="table__item price">
                        <template v-if="serviceItem.levelDiscount > 0">
                          <span style="display:none">TotalStatementDetail D</span>會員價： {{ memberPrice(serviceItem) }}
                          <br />
                          <del class="line-through-price">售價：{{ serviceItem.price }}</del>
                        </template>
                        <template v-else>
                          {{ serviceItem.price }}
                        </template>
                      </div>
                      <div class="table__item qty">{{ `x${serviceItem.qty}` }}</div>
                      <div class="table__item count">{{ serviceItem.total }}</div>
                    </div>

                    <div v-if="prepaidDeductItem.priceId" class="table__row">
                      <div class="table__title">{{ prepaidDeductItem.title }}</div>
                      <div class="table__single">{{ prepaidDeductItem.total }}</div>
                    </div>

                    <div v-if="couponItem.priceId" class="table__row">
                      <div class="table__title">{{ `優惠券 (${couponItem.title})` }}</div>
                      <div class="table__single">{{ couponItem.total }}</div>
                    </div>

                    <div class="table__row">
                      <div class="table__title">小計</div>
                      <div class="table__single">{{ serviceTotal }}</div>
                    </div>
                  </div>

                  <template v-if="params.length > 0">
                    <div class="table__box">
                      <div v-for="item in params" :key="item.id" class="table__row">
                        <div class="table__title">
                          <span v-html="formatParamTitle(item)"></span>
                        </div>
                        <div class="table__item price">
                          <span v-if="item.type === 'cosmetic-add'">
                            <template v-if="item.levelDiscount > 0">
                              <span style="display:none">TotalStatementDetail E</span>會員價： {{ memberPrice(item) }}
                              <br />
                              <del class="line-through-price">售價：{{ item.price }}</del>
                            </template>
                            <template v-else>
                              {{ item.total }}
                            </template>
                          </span>
                          <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                          <span v-else>{{ item.total }} </span>
                        </div>
                        <div class="table__item qty">{{ 'x1' }}</div>
                        <div class="table__item count">{{ item.total }}</div>
                      </div>
                    </div>
                  </template>

                  <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                    <div class="table__row">
                      <div class="table__title" style="width:50%"><span style="display:none">TotalStatementDetail 2C</span>應付金額</div>
                      <div class="table__single" style="width:40%">{{ submitData.payTotal }}</div>
                    </div>
                    <template v-if="submitData.refundHistories && submitData.refundHistories.length > 0">
                      <div v-for="(item, index) in submitData.refundHistories" :key="index" class="table__row">
                        <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                        <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%"> -{{ item.Amt }}</div>
                        <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }} </div>
                      </div>
                    </template>
                  </div>
                </div>
                <BaseCollapse title="付款資訊">
                  <TotalStatementDetailSectionPayment :default-value="submitData" :installment-data="installmentData" />
                </BaseCollapse>
              </div>
              <div class="d-flex mt-3 table__btn">
                <el-button class="is-round w-100 mr-1" @click="changeIsActiveItem('main')">{{ isActiveItem.includes('main') ? '隱藏' : '顯示' }}訂單資訊</el-button>
                <el-dropdown ref="more" trigger="click" :hide-on-click="true" @command="handleCommand">
                  <div>
                    <el-button class="is-round w-100 ml-1"> <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" />更多功能 </el-button>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <!-- Employee -->
                    <template v-if="orderType === 'reservation' && isEmployee">
                      <el-dropdown-item v-if="submitData.status !== 0 && !isPaid(submitData)" :command="{ command: 'editOpenTotalEdit', index: 'main' }">編輯加購</el-dropdown-item>
                      <el-dropdown-item :command="{ command: 'editOpenHistory', index: 'main' }">訂單變更記錄</el-dropdown-item>
                      <el-dropdown-item v-if="submitData.status !== 0 && submitData.status !== 6 && isChildren" :command="{ command: 'tryToCancelOrder', index: 'main' }">取消訂單</el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>

            <div v-for="(addOrder, index) in childrenOrders" :key="addOrder.id" class="table__blockInner" style="margin-bottom: 30px" :class="{ isStyleIsEmployee: isEmployee }">
              <div class="table__blockTitle">
                <span class="mr-1 ml-0">{{ orderTitle(addOrder, 'isChildren') }}</span>
                <template v-if="addOrder.status === 0">
                  <BaseStateLabel state="info" text>
                    <span style="font-size:12px">{{ addOrder.status | bookingStatusFilter('text') }}</span>
                  </BaseStateLabel>
                </template>
                <template v-else>
                  <template v-if="orderType === 'reservation'">
                    <BaseStateLabel :state="addOrder.paymentStatus | paymentStatusMapFilter('color')" text>
                      <span style="font-size:12px">{{ addOrder.paymentStatus | paymentStatusMapFilter('text') }}</span>
                    </BaseStateLabel>
                  </template>
                </template>
                <div class="mt-1">
                  應付金額：<span class="text-secondary">{{ addOrder.payTotal }}</span>
                </div>
              </div>
              <div class="table__content" :class="{ isActive: isActiveItem.includes(index), isStyleIsEmployee: isEmployee }">
                <div class="table__contentInner mt-2" :class="{ isStyleIsEmployee: isEmployee }">
                  <div>
                    <div class="table__head isEdit">
                      <div class="table__title"> <span style="display:none">TotalStatementDetail ad2</span>加購項目 </div>
                      <div class="table__item price"> 售價 </div>
                      <div class="table__item qty"> 數量 </div>
                      <div class="table__item count"> 小計 </div>
                    </div>
                  </div>

                  <template v-if="addOrder.params.length > 0">
                    <div class="table__box">
                      <div v-for="item in addOrder.params" :key="item.id" class="table__row">
                        <div class="table__title">
                          <span v-html="formatParamTitle(item)"></span>
                        </div>
                        <div class="table__item price">
                          <span v-if="item.type === 'cosmetic-add'">
                            <template v-if="serviceItem.levelDiscount > 0">
                              <span style="display:none">TotalStatementDetail F</span>會員價： {{ memberPrice(item) }}
                              <br />
                              <del class="line-through-price">售價：{{ item.price }}</del>
                            </template>
                            <template v-else>
                              {{ item.price }}
                            </template>
                          </span>
                          <span v-else-if="item.type === '%'">{{ `${item.description} %` }}</span>
                          <span v-else>{{ item.total }} </span>
                        </div>
                        <div class="table__item qty">{{ 'x1' }}</div>
                        <div class="table__item count">{{ item.total }}</div>
                      </div>
                    </div>
                  </template>

                  <div class="table__box" style="margin-top: 10px;margin-bottom:10px">
                    <div class="table__row">
                      <div class="table__title" style="width:50%"
                        ><span style="display:none">TotalStatementDetail 2D</span>
                        應付金額
                      </div>
                      <div class="table__single" style="width:40%">
                        {{ addOrder.payTotal }}
                      </div>
                    </div>
                    <template v-if="addOrder.refundHistories.length > 0">
                      <div v-for="(item, i) in addOrder.refundHistories" :key="i" class="table__row">
                        <div class="alert-word table__title" style="width:50%">{{ item.refundDate }}退款</div>
                        <div v-if="item.paymentMethod !== 'Deposit'" class=" alert-word table__single" style="width:50%"> -{{ item.Amt }}</div>
                        <div v-else class=" alert-word table__single" style="width:50%">-{{ item.point + item.bonus }} </div>
                      </div>
                    </template>
                  </div>
                </div>
                <BaseCollapse title="付款資訊" small-title>
                  <TotalStatementDetailSectionPayment :default-value="addOrder" />
                </BaseCollapse>
              </div>
              <div class="d-flex mt-3 table__btn">
                <el-button class="is-round w-100 mr-1" @click="changeIsActiveItem(index)">{{ isActiveItem.includes(index) ? '隱藏' : '顯示' }}訂單資訊</el-button>
                <el-dropdown ref="more" trigger="click" :hide-on-click="true" @command="handleCommand">
                  <div>
                    <el-button class="is-round w-100 ml-1"> <BaseIcon name="chevron-down" icon-style="fal" class="mr-2" />更多功能 </el-button>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <!-- Employee -->
                    <template v-if="orderType === 'reservation' && isEmployee">
                      <el-dropdown-item v-if="addOrder.status !== 0 && !isPaid(addOrder)" :command="{ command: 'editOpenTotalEdit', index: index }">編輯加購</el-dropdown-item>
                      <el-dropdown-item v-if="addOrder.status !== 0 && !isPaid(addOrder)" :command="{ command: 'editOpenPaymentMethod', index: index }">編輯付款方式</el-dropdown-item>
                      <el-dropdown-item :command="{ command: 'editOpenHistory', index: index }">訂單變更記錄</el-dropdown-item>
                      <el-dropdown-item v-if="addOrder.status !== 0 && addOrder.status !== 6" :command="{ command: 'tryToCancelOrder', index: index }">取消訂單</el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </template>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<style lang="scss" module>
.wrapper {
  // height: calc(100% - 128px);
  // height: calc(100vh - 100px);
  position: relative;
  height: 100%;

  :global {
    .mb-1 {
      margin-bottom: 1px solid red;
    }

    .userInfo {
      margin-bottom: 10px;
      padding-bottom: 10px;

      li {
        color: $color-secondary;
        margin-bottom: 10px;
      }

      border-bottom: 1px solid $color-line;
    }

    .mobileHidden {
      @include max-md {
        display: none;
      }
    }

    .byOrderExtrafieldsInfo {
      ul {
        border-bottom: 1px solid $color-text-light;
        padding-bottom: 10px;
        margin-bottom: 10px;
        color: $color-text-light;

        li {
          &:not(:last-child) {
            margin-bottom: 10px;
          }

          .value {
            color: $color-secondary;
          }
        }
      }
    }
  }
}

.table {
  padding: 20px 30px 0;
  display: flex;
  flex-direction: column;
  height: 100%;

  @include touch {
    padding-bottom: 30px;
  }

  @include max-md {
    padding: 20px;
  }

  &__topTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    :global {
      .el-button {
      }
    }
  }

  :global {
    .table {
      &__blockInner {
        &.isStyleIsEmployee {
          @include max-md {
            border: 1px solid $color-line;
            padding: 18px;
            border-radius: 18px;
            background: #fff;
          }
        }
      }

      &__block {
        &.isStyleMobile {
          display: none;

          &.isStyleIsEmployee {
            @include max-md {
              display: block;
            }
          }
        }
      }

      &__AllHead {
        background-color: white;
        display: flex;
        padding: 10px;
        justify-content: space-between;

        @include max-md {
          &.isSetyleIsEmployee {
            background-color: #fff;
            margin-bottom: 0;
            padding-bottom: 10px;
          }
        }

        div {
          color: $color-state-service;
        }
      }

      &__orderInfo {
        padding: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background-color: white;

        :global {
          .isOpenRotate {
            transform: rotate(-180deg) translateZ(0);
          }

          .name {
            display: flex;
            align-items: center;

            > p {
              font-size: 16px;
              color: $color-primary;
              letter-spacing: 0.3em;
              margin-top: 0;
              margin-bottom: 0;

              > span {
                color: $color-state-service;
                font-size: 14px;
              }
            }
          }

          .dateTime {
            margin-top: 4px;
            letter-spacing: 0.1em;
          }

          .stateLabel {
            margin-top: 4px;
          }
        }

        &:hover {
          cursor: pointer;
        }
      }

      &__head {
        background-color: #e5e7eb;
        display: flex;
        padding: 10px;
        justify-content: space-between;
        margin-bottom: 10px;

        &.isEdit {
          background-color: #fff;
          margin-bottom: 0;
        }

        @include max-md {
          &.isSetyleIsEmployee {
            background-color: #fff;
            margin-bottom: 0;
            padding-bottom: 10px;
          }
        }
      }

      &__contentInner {
        &.isStyleIsEmployee {
          @include max-md {
            border: 1px solid $color-line;
            // padding: 10px 18px;
            background: #fff;
            margin-bottom: 1rem;
          }
        }
      }

      &__box {
        background-color: #fff;
        // margin-bottom: 10px;
      }

      &__moreBorder {
        border-bottom: $color-border-base 1px solid;
      }

      &__row {
        display: flex;
        padding: 10px;
        justify-content: space-between;

        &:not(:last-child) {
          border-bottom: $color-border-base 1px solid;
        }
      }

      &__bgWhite {
        border-top: 1px solid $color-border-base;
        background-color: white !important;
      }

      &__title {
        width: 50%;
        flex-shrink: 0;
        color: $color-secondary;
      }

      &__item {
        width: 15%;
        text-align: right;
        color: $color-secondary;

        &.price {
          width: 15%;
        }

        &.qty {
          width: 10%;
        }

        &.count {
          width: 15%;
        }
      }

      &__content {
        &.isStyleIsEmployee {
          max-height: 0;
          overflow: hidden;

          &.isActive {
            max-height: 1000px;
            overflow: auto;
          }
        }
      }

      &__single {
        width: 60%;
        text-align: right;
        color: $color-secondary;
      }

      &__button {
        width: 10%;
        text-align: right;
        color: $color-state-info;
        cursor: pointer;
      }

      &__scroll {
        // max-height: calc(100vh - 480px);
        flex: 1;
        overflow: auto;
      }
    }
  }
}

.seeAllOrdersIng {
  border-width: 1.5px;
  border-color: lighten($color-primary, 20%);
  color: $color-primary;
}

.payment {
  :global {
    li {
      line-height: 40px;
    }

    .title {
      margin-right: 20px;
      color: darkgray;
    }
  }
}

.prepaid-used:not(:last-child) {
  margin-bottom: 4px;
}
</style>
